import { render } from "./ImageGenerationFromGroupProductModal.vue?vue&type=template&id=2bfae56b"
import script from "./ImageGenerationFromGroupProductModal.vue?vue&type=script&lang=js"
export * from "./ImageGenerationFromGroupProductModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__